import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { useAppSelector } from '@spartalabs/pdc-core';
import usePageTracking from 'hooks/usePageTracking';
import {
  Login,
  Dashboard,
  Empty,
  EntranceExit,
  Examples,
  CardsExamples,
  ChartsExamples,
  TablesExamples,
  FleetDist,
  Repair,
  Models,
  FinancialList,
  DndExamples,
  Schedules,
  VehicleForm,
  ServicesForm,
  ScheduleForm,
  Payment,
  AccessList,
  AccessUser,
  FaQ,
  FormQuestion,
  FaqQuestion,
  QuestionList,
  EditCategorie,
  ContractsList,
  Contract,
  Logs,
  MultipleForm,
  TableView,
  Vehicles,
} from 'pages';
import { isProd } from 'utils/functions';

export const AppRoutes = () => {
  if (isProd()) usePageTracking();

  const { token } = useAppSelector(state => state.authSlicer.user);

  if (!token) {
    return (
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="*" element={<Navigate to="/login" />} />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route path="/" element={<Navigate to="/inicio" />} />

      <Route path="/login" element={<Login />} />

      <Route path="/inicio" element={<Dashboard />} />

      <Route path="/relatorios">
        <Route index element={<Empty />} />
        <Route path="modelos" element={<Models />} />
        <Route path="manutencao">
          <Route path="entradasaida" element={<EntranceExit />} />
          <Route path="servicos" element={<Repair />} />
        </Route>
        <Route path="distdefrotas" element={<FleetDist />} />
      </Route>

      <Route path="/agendamentos" element={<Schedules />} />

      <Route path="/novo-agendamento">
        <Route index element={<Empty />} />
        <Route path="veiculos" element={<VehicleForm />} />
        <Route path="servicos" element={<ServicesForm />} />
        <Route path="agenda" element={<ScheduleForm />} />
        <Route path="lote" element={<MultipleForm />} />
        <Route path="revisao" element={<TableView />} />
      </Route>

      <Route path="/centraldeduvidas">
        <Route index element={<FaQ />} />
        <Route path="lista/:name?/:id" element={<QuestionList />} />
        <Route path="pergunta/:name?/:id" element={<FaqQuestion />} />
        <Route path="pergunta/criar" element={<FormQuestion />} />
        <Route path="pergunta/editar/:id" element={<FormQuestion isEdit />} />
        <Route path="editarcategorias" element={<EditCategorie />} />

        {/* Pivotado  <Route path="/centraldeduvidas" element={<CallCenter />} /> */}
      </Route>

      <Route path="/faturamento">
        <Route index element={<FinancialList />} />
        <Route path="mediacao/:id" element={<Payment />} />
      </Route>

      <Route path="logs" element={<Logs />} />

      <Route path="*" element={<Empty />} />

      {!isProd() && (
        <>
          <Route path="/acessos" element={<AccessList />} />
          <Route path="/acessos/usuario" element={<AccessUser />} />

          <Route path="/gestaodecontratos">
            <Route path="contrato/:id" element={<Contract />} />
            <Route index element={<ContractsList />} />
          </Route>

          <Route path="/exemplos">
            <Route path="" element={<Examples />} />
            <Route path="cards" element={<CardsExamples />} />
            <Route path="graficos" element={<ChartsExamples />} />
            <Route path="tabelas" element={<TablesExamples />} />
            <Route path="dnd" element={<DndExamples />} />
          </Route>

          <Route path="veiculos" element={<Vehicles />} />
        </>
      )}
    </Routes>
  );
};
